<div
  class="visual-hint-container hidden-print"
  [ngClass]="{ 'visual-hint--show': shouldDisplay }"
>
  <div class="visual-hint"></div>
</div>
